import { NavLink, useParams } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

import {
  Breadcrumb,
  Card,
  DropdownMenu,
  ListLayout,
  MoreButton,
  PageTitle,
  PageWrapper,
} from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { useBookingRulesDetailsQuery } from '../queries';
import { StepList } from './step-list';

export function Page() {
  const { method } = useParams();
  const { t } = useTranslation();

  const { data } = useBookingRulesDetailsQuery({ method: method! });

  if (!data) {
    return null;
  }

  return (
    <PageWrapper gap="lg" variant="center">
      <PageTitle.Wrapper>
        <PageTitle.Stack>
          <Breadcrumb aria-label={t('common.breadcrumbs')}>
            <DropdownMenu.Root modal={false}>
              <DropdownMenu.Trigger>
                <MoreButton style={{ display: 'inline', verticalAlign: 'top' }} />
              </DropdownMenu.Trigger>

              <DropdownMenu.Content align="start" sideOffset={6} style={{ minWidth: 140, width: 'auto' }}>
                <DropdownMenu.Item asChild>
                  <RouterLink to="../..">{t('common.settings')}</RouterLink>
                </DropdownMenu.Item>
              </DropdownMenu.Content>
            </DropdownMenu.Root>

            <NavLink to="..">{t('common.bookingRules')}</NavLink>
            <span aria-current="page">{method}</span>
          </Breadcrumb>
        </PageTitle.Stack>
      </PageTitle.Wrapper>

      <Card.List>
        <Card.Wrapper>
          <Card.Header>{t('common.shippingMethod')}</Card.Header>
          <Card.Content>{data.method}</Card.Content>
        </Card.Wrapper>

        <Card.Wrapper>
          <Card.Header>{t('common.bookingRules')}</Card.Header>
          <Card.Content>
            <ListLayout.Column>
              <StepList steps={data.steps ?? []} />
            </ListLayout.Column>
          </Card.Content>
        </Card.Wrapper>
      </Card.List>
    </PageWrapper>
  );
}
